import React from 'react';
import { Divider } from '@telus-uds/components-web';
import { orderPermissionsData } from './orderPermissionsData';

import Block from './components/block';

const OrderPermissions = () => {
  return (
    <>
      <div className="layout-container">
        <Divider space={2} variant={{ inverse: true }}/>
        <Block data={orderPermissionsData} />
      </div>
    </>
  );
};

export default OrderPermissions;
